import Head from 'next/head';
import { Box } from '@mui/material';
import { SliceZone } from '@prismicio/react';

import { createClient } from '../../prismicio';
import { components } from '../../slices';
import Footer from '@components/Footer';

const PressKitPage = ({ page }: any) => {
  return (
    <>
      <Head>
        <title>{page.data.seo_title}</title>
        <meta name="description" content={page.data.description} />
      </Head>
      <Box sx={{ position: 'relative' }}>
        <SliceZone
          slices={page.data.slices}
          components={components}
          context={{ page }}
        />
      </Box>
      <Footer />
    </>
  );
};

export default PressKitPage;

export const getStaticProps = async () => {
  const client = createClient();
  const page = await client.getByUID('press_kit_page', 'press_kit');

  return {
    props: {
      page,
    },
  };
};
